module.exports = __webpack_public_path__ + "img/logo-wave-white.7eecc09d.svg";